module.exports = __webpack_public_path__ + "static/img/deliver_active_bg.91f750d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_index/deliver_active_bg.png
// module id = elkY
// module chunks = 1